<app-loading *ngIf="contentReady"></app-loading>

<div class="invoice-modern-page" style="margin-bottom: 100px;">

  <!-- HERO CARD -->
  <section class="invoice-hero-card">
    <div class="invoice-hero-top">
      <div class="invoice-logo-wrap">
        <img src="/assets/logo color.png" alt="Company Logo" />
      </div>

      <div class="invoice-hero-meta">
        <span class="invoice-badge">{{ 'details' | transloco }}</span>
        <h1>{{ 'invoice' | transloco }}</h1>
        <p>#{{ invoiceId }}</p>
        <small>{{ 'Date' | transloco }}: {{ date }}</small>
      </div>
    </div>
  </section>

  <!-- CUSTOMER INFO -->
  <section class="invoice-card">
    <div class="invoice-section-title">{{ 'Info' | transloco }}</div>

    <div class="invoice-info-list">
      <div class="info-line">
        <span>{{ 'yourname' | transloco }}</span>
        <strong>{{ clientname }}</strong>
      </div>

      <div class="info-line">
        <span>{{ 'yournumber' | transloco }}</span>
        <strong>{{ firstphone }}</strong>
      </div>

      <div class="info-line" *ngIf="secphone">
        <span>{{ 'yoursecnumber' | transloco }}</span>
        <strong>{{ secphone }}</strong>
      </div>

      <div class="info-line info-line--address">
        <span>{{ "address" | transloco }}</span>
        <strong>{{ address }}</strong>
      </div>

      <div class="info-line noPrint" *ngIf="note">
        <span class="note-label">{{ 'note' | transloco }}</span>
        <strong>{{ note }}</strong>
      </div>
    </div>
  </section>

  <!-- PRODUCTS -->
  <section class="invoice-card">
    <div class="invoice-section-title">{{ "Product" | transloco }}</div>

    <div class="invoice-table-wrap">
      <table class="invoice-modern-table">
        <thead>
          <tr>
            <th>{{ "Product" | transloco }}</th>
            <th>{{ "quantity" | transloco }}</th>
            <th>{{ "Unit Price" | transloco }}</th>
            <th>{{ 'total' | transloco }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let product of products; let i = index">
            <td>{{ products[i] }}</td>
            <td>{{ qty[i] }}</td>
            <td>{{ prices[i] }} {{ 'egpe' | transloco }}</td>
            <td>{{ prices[i] * qty[i] }} {{ 'egpe' | transloco }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- SUMMARY -->
  <section class="invoice-card">
    <div class="invoice-section-title">{{ 'details' | transloco }}</div>

    <div class="invoice-summary-list">
      <div class="summary-line">
        <span>{{ "subtotal" | transloco }}</span>
        <strong>{{ this.sumprices }} {{ 'egpe' | transloco }}</strong>
      </div>

      <div class="summary-line">
        <span>{{ 'delivery fees' | transloco }}</span>
        <strong>{{ deliveryfees }} {{ 'egpe' | transloco }}</strong>
      </div>

      <div class="summary-line summary-line--discount">
        <span>{{ "discount" | transloco }}</span>
        <strong>{{ discount }} {{ 'egpe' | transloco }}</strong>
      </div>

      <div class="summary-line summary-line--total">
        <span>{{ 'total' | transloco }}</span>
        <strong>{{ this.sumprices + deliveryfees - discount }} {{ 'egpe' | transloco }}</strong>
      </div>
    </div>
  </section>

  <!-- FOOTER -->
  <section class="invoice-thankyou-card">
    <p>{{ "Thank For Choosing lio !" | transloco }}</p>
  </section>
</div>